export default __webpack_public_path__ + "static/media/otto.01122936.svg";